import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { Button } from "./ui/button";

const WhatsAppButton = () => {
  const [showModal, setShowModal] = useState(false);
  const phoneNumber = "+31627225807"; // WhatsApp nummer
  const whatsappMessage = "Hallo, ik heb een vraag over Vermado High-End Automotive.";

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(whatsappMessage);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
    setShowModal(false);
  };

  return (
    <>
      {/* Floating Button */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        className="fixed bottom-20 right-6 z-50 md:bottom-4"
      >
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => setShowModal(true)}
          className="bg-[#25D366] hover:bg-[#22c35e] text-white rounded-full p-4 shadow-lg"
        >
          <MessageCircle className="h-6 w-6" />
        </motion.button>
      </motion.div>

      {/* Modal */}
      <AnimatePresence>
        {showModal && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowModal(false)}
              className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
            />

            {/* Modal Content */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="fixed bottom-48 right-6 w-80 bg-black border border-[#B1A06D]/20 rounded-lg shadow-lg z-50 overflow-hidden md:bottom-16"
            >
              <div className="p-6 relative">
                {/* Close Button */}
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors"
                >
                  <X className="h-5 w-5" />
                </button>

                {/* Content */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="bg-[#25D366] rounded-full p-2">
                      <MessageCircle className="h-5 w-5 text-white" />
                    </div>
                    <h3 className="text-white font-semibold">WhatsApp Contact</h3>
                  </div>

                  <p className="text-white/70 text-sm leading-relaxed">
                    Welkom bij Vermado High-End Automotive! Heb je een vraag? Wij staan voor je klaar via WhatsApp. 
                    Meestal reageren we binnen 30 minuten tijdens werkuren.
                  </p>

                  <Button
                    onClick={handleWhatsAppClick}
                    className="w-full bg-[#25D366] hover:bg-[#22c35e] text-white font-semibold tracking-wide"
                  >
                    START WHATSAPP CHAT
                  </Button>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default WhatsAppButton; 